import { useEffect, useState, useRef, useCallback } from "react";
import axios from "axios";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { 
    Box, Button, Container, Table, Pagination, TableBody, TableCell, 
    TableHead, TableRow, TextField, Card, Typography, 
    Stack, Chip, TableContainer, CircularProgress, InputAdornment, MenuItem, Grid, CardContent
} from "@mui/material";
import { 
    Search as SearchIcon, HistoryOutlined,
    ConfirmationNumberOutlined, AccountBalanceWalletOutlined, 
    TrendingUpOutlined, TrendingDownOutlined
} from "@mui/icons-material";
import { DashboardLayout } from "../../components/dashboard-layout";
import { theme } from "../../theme";
import { GetNameChoose } from "../../funcUtils";

const metronicTheme = createTheme({
    palette: {
        background: { default: "#F5F8FA", paper: "#FFFFFF" }, 
        text: { primary: "#181C32", secondary: "#7E8299" }, 
        primary: { main: "#1B84FF", light: "#F1FAFF" },
        success: { main: "#50CD89", light: "#E8FFF3" },
        danger: { main: "#F1416C", light: "#FFF5F8" },
        warning: { main: "#FFC700", light: "#FFF8DD" },
    },
    typography: { fontFamily: "'Plus Jakarta Sans', sans-serif" },
    components: {
        MuiCard: { styleOverrides: { root: { borderRadius: "12px", boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.03)", border: "1px solid #E4E6EF" } } },
        MuiTableCell: { styleOverrides: { root: { borderBottom: "1px dashed #EFF2F5 !important", padding: "14px 12px", color: "#3F4254", fontSize: "0.85rem", fontFamily: "'Plus Jakarta Sans', sans-serif !important" } } },
        MuiButton: { styleOverrides: { root: { fontFamily: "'Plus Jakarta Sans', sans-serif", textTransform: 'none' } } }
    }
});

const gameHalls = [
    { id: "all", name: "Tất cả sảnh" },
    { id: "112", name: "SEXY" }, { id: "140", name: "JILI" }, { id: "4", name: "AG" }, 
    { id: "79", name: "BBIN" }, { id: "104", name: "CMD" }, { id: "16", name: "CQ9" }, 
    { id: "98", name: "PG" }, { id: "275", name: "168Game" },
    { id: "27", name: "DG" }, { id: "86", name: "Evolution" }, { id: "142", name: "FB" }, 
    { id: "121", name: "KingMaker" }, { id: "102", name: "V8 Poker" }, { id: "123", name: "King Poker" }, 
    { id: "43", name: "MG" }, { id: "39", name: "PP" }, { id: "174", name: "SABA" }, 
    { id: "54", name: "SBO" }, { id: "151", name: "UG" }, { id: "118", name: "WM" }, 
    { id: "99", name: "TF" }, { id: "111", name: "Playtech" }, { id: "28", name: "Allbet" }, 
    { id: "55", name: "JDB" }, { id: "202", name: "WS168" }, { id: "61", name: "IMES" }, { id: "132", name: "SV388" }
];

axios.interceptors.request.use((config) => {
    const token = localStorage.getItem("user");
    if (token) config.headers["Authorization"] = `Bearer ${token}`;
    return config;
}, (error) => Promise.reject(error));

const renderSmallDice = (numStr, key) => {/* Giữ nguyên hàm của bạn */};
const renderSmallCoin = (valStr, key) => {/* Giữ nguyên hàm của bạn */};

function HistoryCasino() {
    function formatDateGame(timeStr) {
        if (!timeStr) return "";
        const m = new Date(timeStr);
        return `${m.getFullYear()}/${("0" + (m.getMonth() + 1)).slice(-2)}/${("0" + m.getDate()).slice(-2)}  ${("0" + m.getHours()).slice(-2)}:${("0" + m.getMinutes()).slice(-2)}:${("0" + m.getSeconds()).slice(-2)}`;
    }

    const [data, setData] = useState([]); 
    const [users, setUsers] = useState([]); 
    
    // States cho Bộ Lọc
    const [selectedUser, setSelectedUser] = useState("all"); 
    const [startDate, setStartDate] = useState(new Date()); 
    const [endDate, setEndDate] = useState(new Date());     
    const [searched, setSearched] = useState("");
    const [selectedSanh, setSelectedSanh] = useState("all"); 
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    
    const [isLoading, setLoading] = useState(false);
    const typingTimeoutRef = useRef(null);
    
    // Thống kê 4 cột
    const [stats, setStats] = useState({ tickets: 0, totalBet: 0, totalWin: 0, totalLose: 0 });
    const [isOpen, setIsOpen] = useState(false);
    const [total, setTotal] = useState(null);

    const openPopup = (item) => { setTotal(item); setIsOpen(true); };
    const closePopup = () => setIsOpen(false);

    // ==========================================
    // LẤY DỮ LIỆU TỪ DATABASE (SERVER-SIDE)
    // ==========================================
    const fetchHistoryFromDB = useCallback(async () => {
        setLoading(true);
        try {
            // Định dạng ngày
            const fmtStart = `${startDate.getFullYear()}-${String(startDate.getMonth() + 1).padStart(2, "0")}-${String(startDate.getDate()).padStart(2, "0")}`;
            const fmtEnd = `${endDate.getFullYear()}-${String(endDate.getMonth() + 1).padStart(2, "0")}-${String(endDate.getDate()).padStart(2, "0")}`;

            const payload = {
                startDate: fmtStart,
                endDate: fmtEnd,
                sanh: selectedSanh,
                username: selectedUser,
                search: searched,
                page: page,
                limit: 20 // 20 dòng 1 trang
            };

            // GỌI API MỚI DÀNH CHO ADMIN
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/casino/admin-history-db`, payload);
            
            if (res.data?.success) {
                setData(res.data.data.data);
                setTotalPages(res.data.data.totalPages);
                
                // Cập nhật thống kê từ Server
                const serverStats = res.data.data.stats;
                setStats({
                    tickets: res.data.data.totalRecords,
                    totalBet: serverStats.totalBet, // Nếu server CHƯA nhân 1000 thì bạn ghi là: serverStats.totalBet * 1000
                    totalWin: serverStats.totalWin,
                    totalLose: serverStats.totalLose
                });
            } else {
                setData([]);
            }
        } catch (error) {
            console.error("Lỗi fetch lịch sử DB:", error);
            setData([]);
        } finally {
            setLoading(false);
        }
    }, [startDate, endDate, selectedSanh, selectedUser, searched, page]);

    // Lắng nghe sự thay đổi của bộ lọc để fetch lại data
    useEffect(() => {
        fetchHistoryFromDB();
    }, [fetchHistoryFromDB]);

    // Lấy danh sách User để nhét vào Dropdown
    const fetchAllUsersData = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/auth/getall?page=1&limit=5000&search=`);
            if (res.data?.success) {
                setUsers(res.data.data);
            }
        } catch (error) {
            console.error("Lỗi lấy User: ", error);
        }
    };

    useEffect(() => { 
        fetchAllUsersData();
    }, []); 
    
    // Xử lý Typing Delay cho ô Tìm kiếm
    const handleSearchChange = (e) => {
        const value = e.target.value;
        if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
        typingTimeoutRef.current = setTimeout(() => { 
            setPage(1); // Reset về trang 1 khi tìm kiếm
            setSearched(value); 
        }, 600);
    };

    const handleChangePage = (e, newPage) => {
        setPage(newPage);
    };

    // Reset page khi đổi bộ lọc
    const handleFilterChange = (setter) => (e) => {
        setPage(1);
        setter(e.target.value);
    };

    const tableHeadSx = { color: "#A1A5B7 !important", fontWeight: "800 !important", fontSize: "0.75rem !important", backgroundColor: "#FFFFFF !important", borderBottom: "2px solid #EFF2F5 !important", textTransform: "uppercase !important", whiteSpace: "nowrap" };

    const productId = (data) => {
        if(!data) return "";
        const hall = gameHalls.find(h => h.id === String(data));
        return hall ? hall.name : data;
    };

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                <ThemeProvider theme={metronicTheme}>
                    <style>{`
                        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
                        .safe-history-zone * { box-sizing: border-box; font-family: 'Plus Jakarta Sans', sans-serif !important; }
                        /* GIỮ NGUYÊN CSS DATEPICKER CỦA BẠN VÀO ĐÂY */
                        .custom-datepicker-input { border: 1px solid #E4E6EF; border-radius: 8px; padding: 8px 12px; width: 120px; text-align: center; color: #3F4254; font-weight: 600; cursor: pointer; outline: none; background-color: #FFFFFF; }
                    `}</style>
                    <Box className="safe-history-zone" component="main" sx={{ flexGrow: 1, py: 4, backgroundColor: '#F5F8FA', minHeight: '100vh' }}>
                        
                        <Container maxWidth="xl">
                            
                            {/* HEADER TOOLBAR */}
                            <Box display="flex" justifyContent="space-between" alignItems="center" mb={4} flexWrap="wrap" gap={2}>
                                <Box display="flex" alignItems="center" gap={1.5}>
                                    <HistoryOutlined sx={{ fontSize: '2.5rem', color: '#1B84FF' }} />
                                    <Box>
                                        <Typography variant="h4" fontWeight="800" color="#181C32">Lịch sử chơi</Typography>
                                        <Typography variant="body2" color="text.secondary">Quản lý trực tiếp từ Cơ sở dữ liệu</Typography>
                                    </Box>
                                </Box>
                                <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap alignItems="center">
                                    <TextField select size="small" value={selectedSanh} onChange={handleFilterChange(setSelectedSanh)} sx={{ minWidth: "150px", backgroundColor: "#FFF" }}>
                                        {gameHalls.map((h) => <MenuItem key={h.id} value={h.id}>{h.name}</MenuItem>)}
                                    </TextField>
                                    
                                    <TextField select size="small" value={selectedUser} onChange={handleFilterChange(setSelectedUser)} sx={{ minWidth: "180px", backgroundColor: "#FFF" }}>
                                        <MenuItem value="all">Tất cả thành viên</MenuItem>
                                        {users.map((u) => (
                                            <MenuItem key={u._id} value={u.username}>{u.username} {u.name ? `(${u.name})` : ''}</MenuItem>
                                        ))}
                                    </TextField>
                                    
                                    <TextField 
                                        size="small" placeholder="Tìm mã cược, game..." onChange={handleSearchChange} 
                                        InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon sx={{color: '#A1A5B7'}}/></InputAdornment> }} 
                                        sx={{ width: "210px", backgroundColor: "#FFF" }} 
                                    />
                                    
                                    <Box sx={{ display: 'flex', alignItems: 'center', backgroundColor: '#FFFFFF', p: '6px 12px', borderRadius: '8px', border: '1px solid #E4E6EF' }}>
                                        <Typography variant="caption" fontWeight="700" color="text.secondary" sx={{ mr: 1.5 }}>TỪ:</Typography>
                                        <DatePicker 
                                            selected={startDate} 
                                            onChange={(d) => { setPage(1); setStartDate(d); }} 
                                            dateFormat="dd/MM/yyyy" selectsStart startDate={startDate} endDate={endDate}
                                            customInput={<input className="custom-datepicker-input" readOnly/>} 
                                        />
                                        <Typography variant="caption" fontWeight="700" color="text.secondary" sx={{ ml: 2, mr: 1.5 }}>ĐẾN:</Typography>
                                        <DatePicker 
                                            selected={endDate} 
                                            onChange={(d) => { setPage(1); setEndDate(d); }} 
                                            dateFormat="dd/MM/yyyy" selectsEnd startDate={startDate} endDate={endDate} minDate={startDate}
                                            customInput={<input className="custom-datepicker-input" readOnly/>} 
                                        />
                                    </Box>
                                </Stack>
                            </Box>

                            {/* THỐNG KÊ 4 CỘT */}
                            <Grid container spacing={2} mb={3}>
                                {/* ... [Giữ nguyên 4 Cột Thống Kê Giao Diện Của Bạn] ... */}
                                <Grid item xs={12} sm={6} lg={3}>
                                    <Card sx={{ backgroundColor: '#1B84FF', color: '#FFF' }}>
                                        <CardContent sx={{ p: '16px !important' }}>
                                            <Typography variant="caption" sx={{ fontWeight: 700 }}>SỐ LƯỢNG CƯỢC</Typography>
                                            <Typography variant="h5" fontWeight="800">{stats.tickets.toLocaleString('vi-VN')}</Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} sm={6} lg={3}>
                                    <Card sx={{ backgroundColor: '#FFF' }}>
                                        <CardContent sx={{ p: '16px !important' }}>
                                            <Typography variant="caption" color="text.secondary" fontWeight="700">TỔNG TIỀN CƯỢC</Typography>
                                            <Typography variant="h5" fontWeight="800" color="#181C32">{stats.totalBet.toLocaleString('vi-VN')} đ</Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} sm={6} lg={3}>
                                    <Card sx={{ backgroundColor: '#E8FFF3', border: '1px solid #50CD89' }}>
                                        <CardContent sx={{ p: '16px !important' }}>
                                            <Typography variant="caption" fontWeight="700" color="#50CD89">TỔNG TIỀN THẮNG</Typography>
                                            <Typography variant="h5" fontWeight="800" color="#50CD89">+{stats.totalWin.toLocaleString('vi-VN')} đ</Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                                <Grid item xs={12} sm={6} lg={3}>
                                    <Card sx={{ backgroundColor: '#FFF5F8', border: '1px solid #F1416C' }}>
                                        <CardContent sx={{ p: '16px !important' }}>
                                            <Typography variant="caption" fontWeight="700" color="#F1416C">TỔNG TIỀN THUA</Typography>
                                            <Typography variant="h5" fontWeight="800" color="#F1416C">-{stats.totalLose.toLocaleString('vi-VN')} đ</Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>

                            {/* BẢNG DỮ LIỆU CHI TIẾT */}
                            <Card sx={{ p: 0 }}>
                                {isLoading ? (
                                    <Box sx={{ p: 10, textAlign: 'center' }}><CircularProgress /></Box>
                                ) : (
                                <TableContainer sx={{ overflowX: 'auto' }}>
                                    <Table sx={{ minWidth: 1460 }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{...tableHeadSx, pl: 3}}>MÃ CƯỢC</TableCell>
                                                <TableCell sx={tableHeadSx}>TÊN ĐĂNG NHẬP</TableCell>
                                                <TableCell sx={tableHeadSx}>SẢNH</TableCell>
                                                <TableCell sx={tableHeadSx}>GAME</TableCell>
                                                <TableCell align="right" sx={tableHeadSx}>TIỀN CƯỢC</TableCell>
                                                <TableCell align="right" sx={tableHeadSx}>THẮNG / THUA</TableCell>
                                                <TableCell align="center" sx={tableHeadSx}>TRẠNG THÁI</TableCell>
                                                <TableCell align="right" sx={{...tableHeadSx, pr: 3}}>THỜI GIAN</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        
                                        <TableBody>
                                            {data && data.length > 0 ? (
                                                data.map((item, idx) => {
                                                    const displayUser = (item?.username || "").replace(/^w/i, '');
                                                    const displayHall = productId(item?.productType) || item?.sanh;
                                                    let actualPnl = Number(item?.netPnl || 0);
                                                    let isWin = actualPnl > 0;
                                                    let isLose = actualPnl < 0;

                                                    return (
                                                        <TableRow key={idx} hover sx={{ verticalAlign: 'middle' }}>
                                                            <TableCell sx={{ pl: 3, fontWeight: 600, color: "#A1A5B7", fontSize: '13px' }}>{item.betOrderNo || item.id_bet?.id_bet}</TableCell>
                                                            <TableCell sx={{ fontWeight: 800, color: "#1B84FF" }}>{displayUser}</TableCell>
                                                            <TableCell sx={{ fontWeight: 700 }}>{displayHall}</TableCell>
                                                            <TableCell sx={{ fontWeight: 600 }}>{item.gameName || item.gameCategory}</TableCell>
                                                            <TableCell align="right" sx={{ fontWeight: 800 }}>{(Number(item.betAmount || item.validBetAmount || 0)).toLocaleString("vi-VN")} đ</TableCell>
                                                            <TableCell align="right" sx={{ fontWeight: 800, color: isWin ? "#50CD89" : (isLose ? "#F1416C" : "#A1A5B7") }}>
                                                                {isWin ? "+" : ""}{(actualPnl).toLocaleString("vi-VN")} đ
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <Chip label={isWin ? "Thắng" : (isLose ? "Thua" : "Hòa")} size="small" sx={{ fontWeight: 800, backgroundColor: isWin ? '#E8FFF3' : (isLose ? '#FFF5F8' : '#F5F8FA'), color: isWin ? '#50CD89' : (isLose ? '#F1416C' : '#7E8299') }}/>
                                                            </TableCell>
                                                            <TableCell align="right" sx={{ pr: 3, color: "#A1A5B7", fontSize: '13px' }}>{formatDateGame(item.createdAt || item.betTime)}</TableCell>
                                                        </TableRow>
                                                    );
                                                })
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={8} align="center" sx={{ py: 6, color: '#A1A5B7', fontWeight: 700 }}>Không tìm thấy dữ liệu!</TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                )}
                                
                                {/* PHÂN TRANG (SERVER-SIDE) */}
                                <Box sx={{ p: 2, display: "flex", justifyContent: "flex-end", alignItems: "center", borderTop: '1px solid #EFF2F5' }}>
                                    {totalPages > 0 && (
                                        <Pagination 
                                            color="primary" shape="rounded" size="small"
                                            page={page} 
                                            count={totalPages} 
                                            onChange={handleChangePage} 
                                            sx={{ '& .MuiPaginationItem-root': { fontWeight: 700 } }} 
                                        />
                                    )}
                                </Box>
                            </Card>
                        </Container>
                    </Box>

                    {/* MODAL KẾT QUẢ XỔ SỐ CỦA BẠN (GIỮ NGUYÊN) */}
                    {/* ... */}

                </ThemeProvider>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default HistoryCasino;